import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
} from "@mui/material";
import React, { useState } from "react";
import {
  useGetMissedCallNumbersQuery,
  useLazyDownloadMissedCallTableLogsQuery,
  useSearchCallLogsQuery,
} from "../store/services/missedCallApi";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";

const CallReport = () => {
  const today = dayjs();

  // ✅ Proper date states
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);

  const [filters, setFilters] = useState({
    start_date: today.format("YYYY-MM-DD"),
    end_date: today.format("YYYY-MM-DD"),
    mobile: "",
    missedcall_numberid: "",
    page: 1,
    limit: 20,
  });
const [downloadCSV] = useLazyDownloadMissedCallTableLogsQuery();
  const { data, isLoading, error, refetch } = useSearchCallLogsQuery(filters);
  const { data: missedCallNumbers } = useGetMissedCallNumbersQuery();

  const logs = data?.data || [];
  const total = data?.total || 0;
  const totalPages = Math.ceil(total / filters.limit);

  // ✅ Handle Date Change (Main Fix)
  const handleDateChange = (type, value) => {
    if (!value) return;

    let newStart = startDate;
    let newEnd = endDate;

    if (type === "start") {
      newStart = value;

      // restrict max 1 month
      if (endDate.diff(value, "month", true) > 1) {
        newEnd = value.add(1, "month");
        setEndDate(newEnd);
      }

      setStartDate(newStart);
    } else {
      // type === "end"
      if (value.diff(startDate, "month", true) > 1) {
        return; // block invalid
      }
      newEnd = value;
      setEndDate(newEnd);
    }

    setFilters((prev) => ({
      ...prev,
      start_date: newStart.format("YYYY-MM-DD"),
      end_date: newEnd.format("YYYY-MM-DD"),
      page: 1,
    }));
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value, page: 1 }));
  };
  const handleDownload = async () => {
    try {
      const blob = await downloadCSV(filters).unwrap();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");

      a.href = url;
      a.download = "missed_call_report.csv";
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed", err);
    }
  };
  const handleSearch = () => refetch();

  const getMaxEndDate = () => {
    const oneMonthLater = startDate.add(1, "month");
    return oneMonthLater.isBefore(dayjs()) ? oneMonthLater : dayjs();
  };

  const inputSx = {
    borderRadius: "0.5rem",
    minWidth: 140,
    "& .MuiOutlinedInput-root": {
      background: "rgba(255,255,255,0.7)",
      "& fieldset": { borderColor: "#E2E8F0" },
      "&:hover fieldset": { borderColor: "#94A3B8" },
    },
    "& .MuiInputLabel-root": { color: "#475569" },
    "& .Mui-disabled": {
      "& .MuiOutlinedInput-input": {
        color: "#334155 !important",
        WebkitTextFillColor: "#334155 !important",
      },
      "& .MuiOutlinedInput-notchedOutline": { borderColor: "#CBD5E1" },
    },
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Missed Call Report
      </Typography>

      {/* 🔍 Filters */}
      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center", elevation: 2, borderRadius: "0.5rem", padding: "1rem", backgroundColor: "#ffffff52", backdropFilter: "blur(10px)", boxShadow: "0 4px 12px rgba(14,165,233,0.1)", mb: 2 }}>
       <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DatePicker
    label="Start Date"
    value={startDate}
    onChange={(val) => handleDateChange("start", val)}
    maxDate={dayjs()}
    format="DD/MM/YYYY"
    sx={{
      ...inputSx,
      width: 150,
      minWidth: 150,
    }}
    slotProps={{
      textField: {
        size: "small",
      },
    }}
  />

  <DatePicker
    label="End Date"
    value={endDate}
    onChange={(val) => handleDateChange("end", val)}
    minDate={startDate}
    maxDate={getMaxEndDate()}
    format="DD/MM/YYYY"
    sx={{
      ...inputSx,
      width: 150,
      minWidth: 150,
    }}
    slotProps={{
      textField: {
        size: "small",
      },
    }}
  />
</LocalizationProvider>

        <TextField
          label="Missedcall Number"
          name="missedcall_numberid"
          select
          value={filters.missedcall_numberid}
          onChange={handleInput}
          size="small"
          sx={inputSx}
        >
          <MenuItem value="">All</MenuItem>
          {missedCallNumbers?.data?.map((num) => (
            <MenuItem key={num.missedcall_numberid} value={num.missedcall_numberid}>
              {num.virtual_number}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          label="Customer Number"
          name="mobile"
          value={filters.mobile}
          onChange={handleInput}
          size="small"
          sx={inputSx}
        />

        <Button variant="contained" onClick={handleSearch} sx={{ height: 35, borderRadius: "8px", fontSize: "0.75rem" }}>
          Search
        </Button>
        <Button
  variant="outlined"
  onClick={handleDownload}
  sx={{ height: 35, borderRadius: "8px", fontSize: "0.75rem" }}
>
  Download CSV
</Button>
      </Box>

      {isLoading && <Typography>Loading...</Typography>}
      {error && <Typography color="error">Error fetching logs</Typography>}

      {/* 📊 Table */}
      <TableContainer component={Paper} sx={{ borderRadius: 0.5, }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              {[
                "Log ID",
                "Date",
                "Missedcall Number",
                "Customer Number",
                "Reply SMS",
                "Mobile Alert",
                "Status",
              ].map((head) => (
                <TableCell
                  key={head}
                  sx={{
                    bgcolor: "#0288d1",
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "0.8rem",
                    py: 1,
                    borderRight: "0.5px solid #1b1b1bff",
                    textTransform: "capitalize",
                  }}
                >
                  {head}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {logs.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ py: 3 }}>
                  <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
                    No records found
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              logs.map((row) => (
                <TableRow
                  key={row.logid}
                  hover
                  sx={{ "&:last-child td, &:last-child th": { borderBottom: 0 } }}
                >
                  <TableCell sx={tdSx}>{row.logid}</TableCell>
                  <TableCell sx={tdSx}>
                    {dayjs(row.logdate).format("DD/MM/YYYY HH:mm")}
                  </TableCell>
                  <TableCell sx={tdSx}>{row.virtual_number || "-"}</TableCell>
                  <TableCell sx={tdSx}>
                    {row.caller_number || row.logmobile}
                  </TableCell>
                  <TableCell sx={tdSx}>{row.response_sms_status || "Pending"}</TableCell>
                  <TableCell sx={tdSx}>{row.alert_sms_status || "Pending"}</TableCell>
                  <TableCell sx={tdSx}>
                    {row.processed ? "Processed" : "Pending"}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* 📄 Pagination */}
      <Box sx={{ mt: 2, display: "flex", alignItems: "center", gap: 1 }}>
        <Typography sx={{ fontSize: "0.8rem", color: "text.secondary" }}>
          Page {filters.page} of {totalPages || 1}
        </Typography>
        <Pagination
          count={totalPages || 1}
          page={filters.page}
          onChange={(_, page) => setFilters((prev) => ({ ...prev, page }))}
          size="small"
          color="primary"
        />
      </Box>
    </Box>
  );
};

const tdSx = {
  fontSize: "0.8rem",
  py: 1,
  px: 1.5,
  borderBottom: "0.5px solid #1b1b1bff",
  borderRight: "0.5px solid #1b1b1bff",
};

export default CallReport;